import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import * as Yup from 'yup';
import TextField from '../Components/TextField';
import '../Style/Button.css';
import { useState } from 'react';
import '../Form/LoginDesign.css'
import { faUser, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingButton from '@mui/lab/LoadingButton';
import LoginIcon from '@mui/icons-material/Login';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import { ApiLink } from '../APILink/ApiLink';
import authHeader from './authHeader';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_reCAPTCHA_URL_DEV;

function AuthForm(props) {
  const [loading, setLoading] = React.useState(false);
  const [recaptchaVerified, setRecaptchaVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [loginData, setLoginData] = useState({
    email: "",
    password: ""
  })

  const onInputChange = (event) => {
    setLoginData({
      ...loginData,
      [event.target.name]: event.target.value
    })
  }

  const onSubmitHandler = (e) => {
    e.preventDefault()
    props.onSubmit(loginData, setLoading);
    setLoading(true);

  }

  // const onSubmitHandler = (e) => {
  //   e.preventDefault();

  //   if (!recaptchaVerified) {
  //     alert("🚨 Ju lutem verifikoni reCAPTCHA për të vazhduar!");
  //     return;
  //   }

  //   setLoading(true);
  //   props.onSubmit(loginData, setLoading);
  // };


  // const handleRecaptchaChange = async (token) => {
  //   try {
  //     const response = await axios.post(ApiLink.API_URL + "AuthProva/verify-recaptcha",
  //       { token },  // Dërgon tokenin si objekt korrekt
  //       { headers: { "Content-Type": "application/json" } }
  //     );

  //     if (response.data.success) {
  //       console.log("✅ reCAPTCHA verified successfully!");
  //       setRecaptchaVerified(true); // E ruan si të verifikuar
  //     } else {
  //       console.error("🚨 reCAPTCHA failed:", response.data.errors);
  //       alert("Verifikimi i reCAPTCHA dështoi!");
  //     }
  //   } catch (error) {
  //     console.error("🚨 Error verifying reCAPTCHA:", error.response?.data || error.message);
  //     alert("Gabim gjatë verifikimit të reCAPTCHA!");
  //   }
  // };

  ///////////////// Kjo po funksionon me v3

  // useEffect(() => {
  //   // Krijon një event listener për të pritur ngarkimin e reCAPTCHA
  //   window.onRecaptchaLoad = () => {
  //     console.log("✅ reCAPTCHA u ngarkua me sukses!");
  //     setRecaptchaReady(true);
  //   };

  //   // Ngarkon skriptin e reCAPTCHA me event listener
  //   const script = document.createElement("script");
  //   script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
  //   script.async = true;
  //   script.defer = true;
  //   script.onload = window.onRecaptchaLoad;
  //   document.body.appendChild(script);

  //   return () => {
  //     delete window.onRecaptchaLoad; // Fshin eventin kur komponenti unmount
  //   };
  // }, []);



  // const handleRecaptchaVerify = async () => {
  //   if (!recaptchaReady) {
  //     alert("❌ reCAPTCHA nuk është ngarkuar ende! Provo përsëri pas disa sekondash.");
  //     return;
  //   }

  //   try {
  //     const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: "login" });

  //     const response = await axios.post(ApiLink.API_URL + "AuthProva/verify-recaptcha",
  //       { token },  // Dërgon tokenin si objekt korrekt
  //       { headers: { "Content-Type": "application/json" } }
  //     );
  //     if (response.data.success) {
  //       console.log("✅ reCAPTCHA verified successfully! Score:", response.data.score);
  //       setRecaptchaVerified(true);
  //     } else {
  //       console.error("🚨 reCAPTCHA failed:", response.data.errors);
  //       alert("Verifikimi i reCAPTCHA dështoi!");
  //     }
  //   } catch (error) {
  //     console.error("🚨 Error verifying reCAPTCHA:", error.response?.data || error.message);
  //     alert("Gabim gjatë verifikimit të reCAPTCHA!");
  //   }
  // };

  /////////////////////////////////////

  useEffect(() => {
    // Ngarkon reCAPTCHA automatikisht sapo të hapet faqja
    const loadRecaptcha = () => {
      window.grecaptcha.ready(async () => {
        try {
          const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: "homepage" });

          // Dërgon tokenin te backend për verifikim
          const response = await axios.post(ApiLink.API_URL + "AuthProva/verify-recaptcha",
            { token },  // Dërgon tokenin si objekt korrekt
            { headers: { "Content-Type": "application/json" } }
          );
          if (response.data.success && response.data.score > 0.5) {
            setRecaptchaVerified(true);
          } else {
            console.error("🚨 reCAPTCHA failed:");
          }
        } catch (error) {
          console.error("🚨 Error verifying reCAPTCHA:");
        }
      });
    };
    // Ngarkon skriptin e reCAPTCHA v3 nëse nuk është ngarkuar më parë
    if (!window.grecaptcha) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.onload = loadRecaptcha;
      document.body.appendChild(script);
    } else {
      loadRecaptcha();
    }
  }, []);


  return (
    <Formik
      initialValues={props.model
      }
      onSubmit={props.onSubmit}
      validationSchema={Yup.object({
        email: Yup.string().required('This field is required')
          .email('You have to insert a valid email'),
        password: Yup.string().required('This field is required')
      })}
    >
      {formikProps => (
        <Form onSubmit={onSubmitHandler} style={{ display: "flex", flexDirection: "column" }}>
          <div className='Login_input-field'>
            <div className='fab'>
              <FontAwesomeIcon icon={faUser} />
            </div>
            <TextField className='input' placeholder="Email" name="email" type="text" onChange={onInputChange} value={loginData.email} required />
          </div>
          <div className='Login_input-field password-field'>
            <div className='fab'>
              <FontAwesomeIcon icon={faLock} />
            </div>
            <TextField className='input' placeholder="Password" name="password" type={showPassword ? "text" : "password"} onChange={onInputChange} value={loginData.password} required />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
          <div className='Login_input__Butoni__Login'>
            {/* <Button className='Login_btn' disabled={formikProps.isSubmitting} type="submit">LogIn</Button> */}
            {/* <LoadingButton
              style={{ backgroundColor: "#4E7B67" }}
              className='Login_btn'
              size="small"
              // onClick={handleClick}
              endIcon={<LoginIcon />}
              loading={loading}
              loadingPosition="end"
              variant="contained"
              type="submit"
              disabled={formikProps.isSubmitting}
            >
              <span>Log in</span>
            </LoadingButton> */}

            <LoadingButton
              style={{ backgroundColor: "#4E7B67" }}
              className="Login_btn"
              size="small"
              endIcon={<LoginIcon />}
              loading={loading}
              loadingPosition="end"
              variant="contained"
              type="submit"
            >
              <span>Log in</span>
            </LoadingButton>

          </div>
          {/* <div>
            <button onClick={handleRecaptchaVerify} disabled={!recaptchaReady || recaptchaVerified}>
              {recaptchaVerified ? "✅ Verifikuar" : recaptchaReady ? "🔄 Verifiko reCAPTCHA" : "⏳ Duke pritur reCAPTCHA..."}
            </button>
          </div> */}

          <div
            className={`Login_recaptcha-status ${
              recaptchaVerified
                ? "Login_recaptcha-status--verified"
                : "Login_recaptcha-status--checking"
            }`}
          >
            <span className="Login_recaptcha-dot" aria-hidden="true" />
            <span>
              {recaptchaVerified
                ? "reCAPTCHA u verifikua me sukses"
                : "Duke verifikuar sigurinë..."}
            </span>
          </div>


          {/* <ReCAPTCHA
            sitekey="6LeX3P4qAAAAACs4vHUMKx9byckEVi_8R2N5cYuB"
            onChange={handleRecaptchaChange}
          /> */}
        </Form>
      )}
    </Formik>
  );
}

AuthForm.defaultProps = {
  model: {
    email: '',
    password: '',
  },
};


export default AuthForm;